var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"techerDivDisplay"},[_c('title-widge',{attrs:{"title":_vm.title,"desc":_vm.desc,"bgFont":_vm.bgFont}}),(_vm.imgUrls.length > 0)?_c('div',[_c('common-techer-display-widge',{staticClass:"teacher_desc",attrs:{"imgs":_vm.imgUrls}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }